"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Text = _interopRequireDefault(require("../Text"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _utilities = _interopRequireDefault(require("../../utilities"));
var _Select = _interopRequireDefault(require("./Select.proptypes"));
var _SelectItemsDesktop = _interopRequireDefault(require("./SelectItems/SelectItemsDesktop"));
var _SelectItemsMobile = _interopRequireDefault(require("./SelectItems/SelectItemsMobile"));
var _SelectItemsMobileV = _interopRequireDefault(require("./SelectItems/SelectItemsMobileV2"));
var _constant = require("./constant");
var _excluded = ["children", "isCompactSelect"],
  _excluded2 = ["children", "withLabelOpacity", "isCompactSelect"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var InnerBox = _styledComponents.default.div.withConfig({
  displayName: "Select__InnerBox",
  componentId: "sc-a8s67i-0"
})(["width:100%;height:", ";display:block;position:relative;"], function (_ref) {
  var height = _ref.height,
    theme = _ref.theme;
  return height || theme.space.large;
});
var inputWrapperVariants = {
  focused: (0, _styledComponents.css)(["background:", ";border-color:", ";"], function (_ref2) {
    var theme = _ref2.theme;
    return theme.colors.default;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.colors.secondary;
  }),
  error: (0, _styledComponents.css)(["border-color:", ";&:hover{border-color:", ";}"], function (_ref4) {
    var theme = _ref4.theme;
    return theme.colors.primary;
  }, function (_ref5) {
    var theme = _ref5.theme;
    return theme.colors.primary;
  }),
  disabled: (0, _styledComponents.css)(["background-color:", ";&:hover{background:", ";border-color:", ";}"], function (_ref6) {
    var theme = _ref6.theme;
    return theme.colors.greyLighter;
  }, function (_ref7) {
    var theme = _ref7.theme;
    return theme.colors.greyLighter;
  }, function (_ref8) {
    var theme = _ref8.theme;
    return theme.colors.greyLight;
  })
};
var InputWrapper = _styledComponents.default.div.withConfig({
  displayName: "Select__InputWrapper",
  componentId: "sc-a8s67i-1"
})(function (_ref9) {
  var variant = _ref9.variant;
  return (0, _styledComponents.css)(["position:absolute;border:", ";box-sizing:border-box;border-radius:", ";border-color:", ";background-color:", ";", ";height:", ";padding:", ";display:flex;flex-direction:row;justify-content:center;align-items:center;&:hover{cursor:pointer;background:", ";border-color:", ";}", ""], function (_ref10) {
    var noBorder = _ref10.noBorder;
    return noBorder ? '0' : "1px solid";
  }, function (_ref11) {
    var theme = _ref11.theme,
      isCompactSelect = _ref11.isCompactSelect;
    return isCompactSelect ? theme.borderRadius.large : theme.borderRadius.small;
  }, function (_ref12) {
    var theme = _ref12.theme;
    return theme.colors.greyLight;
  }, function (_ref13) {
    var theme = _ref13.theme;
    return theme.colors.default;
  }, function (_ref14) {
    var isCompactSelect = _ref14.isCompactSelect,
      width = _ref14.width;
    return isCompactSelect ? null : "width: ".concat(width);
  }, function (_ref15) {
    var height = _ref15.height,
      theme = _ref15.theme;
    return height || theme.space.large;
  }, function (_ref16) {
    var theme = _ref16.theme;
    return "".concat(theme.space.micro, " ").concat(theme.space.XSmall);
  }, function (_ref17) {
    var theme = _ref17.theme;
    return theme.colors.default;
  }, function (_ref18) {
    var theme = _ref18.theme;
    return theme.colors.secondary;
  }, variant && inputWrapperVariants[variant]);
});
InputWrapper.displayName = 'InputWrapper';
var InputContent = _styledComponents.default.div.withConfig({
  displayName: "Select__InputContent",
  componentId: "sc-a8s67i-2"
})(["display:flex;width:calc(100% - ", ");flex-direction:", ";justify-content:", ";"], function (_ref19) {
  var theme = _ref19.theme;
  return theme.space.standard;
}, function (_ref20) {
  var isCompactSelect = _ref20.isCompactSelect;
  return isCompactSelect ? 'row' : 'column';
}, function (_ref21) {
  var isCompactSelect = _ref21.isCompactSelect;
  return isCompactSelect ? 'left' : 'center';
});

// eslint-disable-next-line react/prop-types
var ValueText = function ValueText(_ref22) {
  var children = _ref22.children,
    isCompactSelect = _ref22.isCompactSelect,
    rest = (0, _objectWithoutProperties2.default)(_ref22, _excluded);
  return /*#__PURE__*/_react.default.createElement(_Text.default, (0, _extends2.default)({
    accessible: false,
    type: isCompactSelect ? 'textSmall' : 'default',
    color: isCompactSelect ? 'greyDarker' : 'neutral'
  }, rest), children);
};
ValueText.propTypes = {
  children: _propTypes.default.node.isRequired
};
var InputValue = (0, _styledComponents.default)(ValueText).withConfig({
  displayName: "Select__InputValue",
  componentId: "sc-a8s67i-3"
})(function (_ref23) {
  var isCompactSelect = _ref23.isCompactSelect;
  return (0, _styledComponents.css)(["display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;padding:0px;outline:none;margin-left:", ";line-height:", ";", ""], function (_ref24) {
    var theme = _ref24.theme;
    return isCompactSelect ? theme.space.tiny : theme.space.none;
  }, function (_ref25) {
    var theme = _ref25.theme;
    return isCompactSelect ? theme.lineHeight.XLarge : theme.lineHeight.normal;
  }, isCompactSelect);
});
InputValue.displayName = 'InputValue';

// eslint-disable-next-line react/prop-types
var SmallText = function SmallText(_ref26) {
  var children = _ref26.children,
    withLabelOpacity = _ref26.withLabelOpacity,
    isCompactSelect = _ref26.isCompactSelect,
    rest = (0, _objectWithoutProperties2.default)(_ref26, _excluded2);
  return /*#__PURE__*/_react.default.createElement(_Text.default, (0, _extends2.default)({
    accessible: false,
    type: isCompactSelect ? 'textSmall' : 'small'
  }, rest, {
    color: isCompactSelect ? 'greyDarker' : 'neutral',
    opacity: withLabelOpacity ? 0.5 : 1
  }), children);
};
SmallText.propTypes = {
  children: _propTypes.default.node.isRequired
};
var Placeholder = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "Select__Placeholder",
  componentId: "sc-a8s67i-4"
})(["font-size:", ";line-height:", ";opacity:0.5;"], function (_ref27) {
  var theme = _ref27.theme;
  return theme.fontSize.normal;
}, function (_ref28) {
  var theme = _ref28.theme;
  return theme.lineHeight.normal;
});
Placeholder.displayName = 'Placeholder';
var inputLabelVariants = {
  error: (0, _styledComponents.css)(["color:", ";"], function (_ref29) {
    var theme = _ref29.theme;
    return theme.colors.primary;
  })
};
var InputLabel = (0, _styledComponents.default)(SmallText).withConfig({
  displayName: "Select__InputLabel",
  componentId: "sc-a8s67i-5"
})(function (_ref30) {
  var variant = _ref30.variant,
    withLabelOpacity = _ref30.withLabelOpacity,
    isCompactSelect = _ref30.isCompactSelect;
  return (0, _styledComponents.css)(["outline:none;color:", ";line-height:", ";margin-bottom:", ";margin-left:", ";white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;", " ", " ", ""], function (_ref31) {
    var theme = _ref31.theme;
    return isCompactSelect ? theme.colors.greyDarker : theme.colors.greyDark;
  }, function (_ref32) {
    var theme = _ref32.theme;
    return isCompactSelect ? theme.lineHeight.XLarge : theme.lineHeight.XSmall;
  }, function (_ref33) {
    var theme = _ref33.theme;
    return isCompactSelect ? theme.space.none : theme.space.micro;
  }, function (_ref34) {
    var theme = _ref34.theme;
    return isCompactSelect ? theme.space.XXSmall : theme.space.none;
  }, variant && inputLabelVariants[variant], withLabelOpacity, isCompactSelect);
});
InputLabel.displayName = 'InputLabel';
var ErrorMessage = (0, _styledComponents.default)(SmallText).withConfig({
  displayName: "Select__ErrorMessage",
  componentId: "sc-a8s67i-6"
})(["color:", ";"], function (_ref35) {
  var theme = _ref35.theme;
  return theme.colors.orange;
});
ErrorMessage.displayName = 'ErrorMessage';
var StyledIcon = (0, _styledComponents.default)(_Icon.default).withConfig({
  displayName: "Select__StyledIcon",
  componentId: "sc-a8s67i-7"
})(["visibility:", ";"], function (_ref36) {
  var hideSelectIcon = _ref36.hideSelectIcon;
  return hideSelectIcon ? 'hidden' : 'visible';
});
var getItem = function getItem(propValue, items) {
  return items.find(function (_ref37) {
    var value = _ref37.value;
    return value === propValue;
  });
};
var Select = function Select(props) {
  var items = props.items,
    value = props.value,
    label = props.label,
    placeholder = props.placeholder,
    validateStatus = props.validateStatus,
    validateMessage = props.validateMessage,
    disabled = props.disabled,
    disableScroll = props.disableScroll,
    isMobile = props.isMobile,
    onChange = props.onChange,
    renderActiveLabel = props.renderActiveLabel,
    renderDisplayValue = props.renderDisplayValue,
    renderOptionLabel = props.renderOptionLabel,
    width = props.width,
    height = props.height,
    accessible = props.accessible,
    theme = props.theme,
    customProperties = props.customProperties,
    isMobileV2 = props.isMobileV2,
    closeOnOutsideClick = props.closeOnOutsideClick,
    isCompactSelect = props.isCompactSelect,
    showCompactIcon = props.showCompactIcon,
    withLabelOpacity = props.withLabelOpacity,
    isShowChildAgeInput = props.isShowChildAgeInput,
    inputIndex = props.inputIndex,
    currentSelect = props.currentSelect,
    setCurrentSelect = props.setCurrentSelect,
    disableActiveLabel = props.disableActiveLabel,
    noBorder = props.noBorder,
    maxHeight = props.maxHeight,
    enablePaxAgeUpdate = props.enablePaxAgeUpdate,
    mobileZIndex = props.mobileZIndex,
    hideSelectIcon = props.hideSelectIcon;
  var tabIndex = !accessible ? '-1' : '0';
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    showPicker = _useState2[0],
    setShowPicker = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    lastToggleShowPicker = _useState4[0],
    setLastToggleShowPicker = _useState4[1];
  var wrapperRef = (0, _react.useRef)(null);
  var iconName = showPicker ? _constant.ICON_EXPAND_LESS : _constant.ICON_EXPAND_MORE;
  var iconColor = 'greyDark';
  _utilities.default.useOutsideClickHandler(wrapperRef, handleClickOutside);
  (0, _react.useEffect)(function () {
    if (isShowChildAgeInput) {
      if (inputIndex === currentSelect) setShowPicker(true);else setShowPicker(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSelect, isShowChildAgeInput]);
  var throttleSetShowPicker = function throttleSetShowPicker(showPickerValue) {
    var now = new Date().getTime();
    if (now - lastToggleShowPicker > _constant.THROTTLE_TOGGLE_SHOW_PICKER) {
      setShowPicker(showPickerValue);
      setLastToggleShowPicker(now);
      if (isShowChildAgeInput) setCurrentSelect(showPickerValue ? inputIndex : null);
    }
  };
  function handleClickOutside() {
    if (closeOnOutsideClick && showPicker) {
      throttleSetShowPicker(false);
    }
  }
  var togglePicker = function togglePicker(event) {
    if (disabled) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    throttleSetShowPicker(!showPicker);
  };
  var handleClickMobile = function handleClickMobile(event) {
    event.preventDefault();
    event.stopPropagation();
    throttleSetShowPicker(true);
  };
  var handleBlur = function handleBlur(event) {
    event.preventDefault();
    event.stopPropagation();
    throttleSetShowPicker(false);
  };
  var onValueChange = function onValueChange(selected, index) {
    if (selected !== null && selected !== void 0 && selected.disabled) return;
    if (showPicker) {
      throttleSetShowPicker(false);
    }
    var item = index >= 0 ? items[index] : {};
    onChange(item.value, item);
    if (isShowChildAgeInput) setCurrentSelect(null);
  };
  var selectedItem = getItem(value, items);
  var renderLabel = function renderLabel() {
    if (renderActiveLabel) {
      return selectedItem ? renderActiveLabel(selectedItem) : label;
    }
    return label;
  };
  var renderValue = function renderValue() {
    if (renderDisplayValue && selectedItem) {
      return renderDisplayValue(selectedItem);
    }
    return selectedItem ? selectedItem.label : '';
  };
  var childAgeList = items && (items === null || items === void 0 ? void 0 : items.length) && (items === null || items === void 0 ? void 0 : items.filter(function (item) {
    return (item === null || item === void 0 ? void 0 : item.label) <= 11;
  }));
  var ageList = enablePaxAgeUpdate ? childAgeList : items;
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(InnerBox, {
      height: height
    }, /*#__PURE__*/_react.default.createElement("div", {
      ref: wrapperRef
    }, /*#__PURE__*/_react.default.createElement(InputWrapper, (0, _extends2.default)({
      width: width,
      height: height,
      onClick: togglePicker,
      onFocus: togglePicker,
      isCompactSelect: isCompactSelect,
      variant: validateStatus || disabled && 'disabled' || showPicker && 'focused'
    }, customProperties, {
      tabIndex: tabIndex,
      noBorder: noBorder
    }), /*#__PURE__*/_react.default.createElement(InputContent, {
      isCompactSelect: isCompactSelect
    }, showCompactIcon && isCompactSelect && /*#__PURE__*/_react.default.createElement(_Icon.default, {
      accessible: false,
      icon: _constant.ICON_SORT,
      color: iconColor,
      fontsize: "titleNormal"
    }), selectedItem ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !disableActiveLabel && /*#__PURE__*/_react.default.createElement(InputLabel, {
      isCompactSelect: isCompactSelect,
      variant: validateStatus,
      withLabelOpacity: withLabelOpacity
    }, renderLabel()), /*#__PURE__*/_react.default.createElement(InputValue, {
      isCompactSelect: isCompactSelect
    }, renderValue())) : /*#__PURE__*/_react.default.createElement(Placeholder, {
      accessible: false,
      color: "greyDark"
    }, renderLabel())), /*#__PURE__*/_react.default.createElement(StyledIcon, {
      hideSelectIcon: hideSelectIcon,
      accessible: false,
      icon: iconName,
      color: iconColor,
      fontsize: "titleNormal"
    })), !disabled && isMobile && /*#__PURE__*/_react.default.createElement(_SelectItemsMobile.default, {
      placeholder: placeholder,
      items: items,
      value: value,
      showPicker: showPicker,
      width: width,
      onClick: handleClickMobile,
      onBlur: handleBlur,
      onValueChange: onValueChange,
      enablePaxAgeUpdate: enablePaxAgeUpdate
    }), !isMobile && !isMobileV2 && /*#__PURE__*/_react.default.createElement(_SelectItemsDesktop.default, {
      disableScroll: disableScroll,
      placeholder: placeholder,
      items: ageList,
      value: value,
      showPicker: showPicker,
      width: width,
      onValueChange: onValueChange,
      renderOptionLabel: renderOptionLabel,
      maxHeight: maxHeight,
      enablePaxAgeUpdate: enablePaxAgeUpdate
    }), !isMobile && isMobileV2 && /*#__PURE__*/_react.default.createElement(_SelectItemsMobileV.default, {
      placeholder: placeholder,
      items: items,
      value: value,
      showPicker: showPicker,
      width: width,
      onValueChange: onValueChange,
      onClick: handleClickMobile,
      onBlur: handleBlur,
      enablePaxAgeUpdate: enablePaxAgeUpdate,
      renderOptionLabel: renderOptionLabel,
      mobileZIndex: mobileZIndex
    }))), validateStatus === _constant.VALIDATE_STATUS_ERROR && validateMessage && /*#__PURE__*/_react.default.createElement(ErrorMessage, {
      accessible: false
    }, validateMessage));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
Select.propTypes = _Select.default.PropTypes;
Select.defaultProps = _Select.default.DefaultProps;
var _default = Select;
exports.default = _default;